export default "__VITE_ASSET__CmQXTwwo__"